import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {RouterProvider} from 'react-router';
import {createBrowserRouter} from 'react-router-dom';
import {store} from './_modules';

/* CSS */
import './index.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'bootstrap/dist/css/bootstrap.min.css';

/* Components */
import Map from './map';
import SearchForm from './searchForm';
import Home from './home';
import SearchResult from './searchResult';
import Describe from './describe';


const router = createBrowserRouter(
    [
      {
        path: '/',
        element: (
          <div className='d-flex flex-column'>
            <Home/>
            <div className='d-flex flex-row'>
              <Map/>
            </div>
          </div>
        ),
      },
      {
        path: '/search',
        element: (
          <div className='d-flex flex-column'>
            <SearchForm/>
            <div className='d-flex flex-row'>
              <SearchResult/>
              <Map/>
            </div>
            <Describe/>
          </div>
        ),
      },
    ],
    {basename: process.env.PUBLIC_URL},
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
    <Provider store={store}>
      <RouterProvider router={router}/>
    </Provider>,
);
